export type ChangeEventPayload = {
  value: string;
};

export type V2rayModuleViewProps = {
  name: string;
};
